import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { AuthService } from '../auth.service';
import { API_URL } from 'src/environments/api-url';
import * as global from '../../includes/global';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { Company, CompanyInfo } from 'src/app/classes/company';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private company = new BehaviorSubject<Company>(null);
  private companyInfo = new BehaviorSubject<CompanyInfo>(null);
  private userRoleType = new BehaviorSubject<string>(null);
  castUserRoleType = this.userRoleType.asObservable();
  castCompany = this.company.asObservable();
  noteUploadingMethods = [
    {
        value: 'progress_note',
        label: 'Progress Note'
    },
    {
        value: 'encounter_note',
        label: 'Encounter Note'
    }, 
    {
      value: 'pdf_document',
      label: 'PDF Document'
    }
];
  constructor(
    private http: HttpService,
    private authService: AuthService,
    private httpclient: HttpClient,
    private commonService: CommonService,
  ) {
    if (this.authService?.currentUser?.account_type === 'company') {
      // console.log("in company service: ",this.authService.authObject ); 
      this.getAssociatedCompanyId(this.authService?.authObject?.id, null).subscribe((response: any) => {
        this.company.next(response.data)
      })
    }
  }
  getCompanyUploadingMethods(company_type:string, source?:'PointClickCare'|'MatrixCare'){
    let result = this.noteUploadingMethods;
    if(company_type.toLowerCase() != 'nursing'){
        result = result.filter((method) => {
            return method.value != 'pdf_document';
        });
      } 
      
      if(source === 'MatrixCare') {
        // remove enounter_note from result
        result = result.filter((method) => {
          return method.value != 'encounter_note';
        });
        
      }
      return result;
  }
  changeUserRoleType(role) {
    this.userRoleType.next(role);
  }
  getSpellCheckOption(user_id) {
    const details = {
      user_id,
    }
    return this.http.post(global.url + API_URL.COMPANY.getSpellCheckOption, details).pipe();
  }
  setSpellCheckOption(company_id, user_id, status) {
    const details = {
      company_id,
      user_id,
      status
    }
    return this.http.post(global.url + API_URL.COMPANY.setSpellCheckOption, details);
  }
  getCompanyName(companyId = null, projection?) {
    const details = {
      companyId,
    }
    if (projection)
      details['projection'] = projection;
    return this.http.post(global.url + API_URL.COMPANY.getCompanyName, details);
  }
  saveCompanyReportSettings(company_id,report_settings) {
    const details = {
      company_id,
      report_settings
    }
    return this.http
      .post(global.url + API_URL.COMPANY.saveCompanyReportSettings, details);
  }
  getCompanyReportSettings(company_id) {

    const details = {
      company_id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getCompanyReportSettings, details);
  }

  getCompanyUsers(company_id, user_type) {
    const details = {
      company_id,
      user_type
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getCompanyUsers, details);
  }
  getCompanyAllUsers(company_id, user_type) {
    const details = {
      company_id,
      user_type
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getCompanyAllUsers, details);
  }
  getCensusColumnSetting(company_id) {
    const details = {
      company_id}
    return this.http
      .post(global.url + API_URL.COMPANY.getCensusColumnSetting, details);
  }
  updateCensusColumnSetting(census_columns, company_id) {
    let data = {
      census_columns, 
      company_id,
      userId: this.authService.currentUser._id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.updateCensusColumnSetting, data);
  }
  getCompanyFacilities(company_id, provider_id = null) {
    const details = {
      company_id,
      provider_id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getCompanyFacilities, details);
  }
  saveChargeSetting(company_id,charge_edit_duration) {
    const details = {
      company_id,
      charge_edit_duration
    }
    return this.http
      .post(global.url + API_URL.COMPANY.saveChargeSetting, details);
  }
  getChargeSetting(company_id) {
    const details = {
      company_id,
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getChargeSetting, details);
  }
  getAssociatedCompanyId(user_id, _id) {
    const details = {
      user_id,
      _id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getAssociatedCompanyId, details);
  }

  getLegalAuthenticator(data){
    return this.http
      .post(global.url + API_URL.COMPANY.getLegalAuthenticator, data);
  }
  addUser(data) { 

    return this.http
      .post(global.url + API_URL.COMPANY.adduser, data);
  }
  addFacility(data) {
    data = {
      ...data,
      userId: this.authService.currentUser._id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.addFacility, data);
  }

  updateFacility(data) {
    data = {
      ...data,
      userId: this.authService.currentUser._id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.updateFacility, data);
  }
  updateInActiveFacility(data) {
    
    return this.http.post(global.url + API_URL.COMPANY.updateInActiveFacility, data).pipe();
  }

  updatePayorUsers(payor_id, user_ids) {
    const details = {
      payor_id,
      user_ids
    }
    return this.http
      .post(global.url + API_URL.COMPANY.updatePayorUsers, details);
  }

  deleteFacility(facility_id) {
    const details = {
      facility_id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.deleteFacility, details);
  }
  getAllCompanies(query?, company_id?) {
    let details: any = {
    }
    if (query) {
      details.query = query;
    }
    company_id ? details.company_id = company_id : null;
    return this.http
      .post(global.url + API_URL.COMPANY.getAllCompanies, details); 
  }
  getCompanyCPTs(company_id?) {
    const details = {
      ...this.authService.authObject,
      companyId: company_id ? company_id : null,
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.getCompanyCPTs, details).pipe();
  }
  getAllPOS() {
    const details = {
      ...this.authService.authObject,
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.getAllPOS, details).pipe();
  }
  updatePOSRelation(companyId, cptId, posID, isCreating, isMultiplePos = false) {
    const details = {
      companyId,
      cptId,
      posID,
      isCreating,
      isMultiplePos
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.updatePOSRelation, details).pipe();
  }
  updateDefaultPOS(companyId, cptId, defaultPOS) {
    const details = {
      ...this.authService.authObject,
      companyId,
      cptId,
      defaultPOS
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.updateDefaultPOS, details).pipe();
  }
  getCPTPOSRelations(filter) {
    const details = {
      filter: filter
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.getCPTPOSRelations, details).pipe();
  }
  getCompanyAssociation(company_id) {
    let details: any = {
      company_id
    }
  
    return this.http
      .post(global.url + API_URL.COMPANY.getCompanyAssociation, details);
  }
  matrixPatientExtract(facility_id, external_id) {
    let details: any = {
      external_id,
      facility_id
    }
  
    return this.http
      .post(global.url + API_URL.MATRIXCARE_MIRTH.matrixPatientExtract, details);
  }
  saveCompanyCompanyRelation(query?) {
    let details: any = {
      ...query
    }
    details.is_active=true;
    return this.http
      .post(global.url + API_URL.COMPANYASSOSIATION.saveCompanyCompanyRelation, details);
  }
  updateCompanyAssociation(filter, updateQuery) {
    return this.http
      .post(global.url + API_URL.COMPANYASSOSIATION.updateCompanyAssociation, { filter, updateQuery });
  }
  getAllCompaniesWithCompanyAssosiation(query?) {
    let details: any = {
      ...query
    }
    details.is_active=true;
    return this.http
      .post(global.url + API_URL.COMPANYASSOSIATION.getAllCompaniesWithCompanyAssosiation, details);
  }
  getAllCompaniesWithTicketsCount(query?) {
    let details: any = {
    }
    if (query) {
      details.query = query;
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getAllCompaniesWithTicketsCount, details);
  }
  getCompaniesFacilityAssociation(filter) {
    const details: any = {
      filter : filter
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getCompaniesFacilityAssociation, details);
  }
  exportCompaniesFacilityAssociationAsXLSX(filter) {
    let details: any = {
      filter
    }
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Length');
    headers.append('Access-Control-Expose-Headers', 'Content-Length');
    headers.append('Content-Type', 'application/octet-stream');

    return this.httpclient.post(global.url + API_URL.COMPANY.exportCompaniesFacilityAssociationAsXLSX, details,
      {
        responseType: "blob",
        reportProgress: true,
        observe: 'events',
        headers
      });
  }
  getAllCompaniesWithCount(filter ?) {
    const details = {
    }
    if (filter)
      details['filter'] = filter;
    return this.http
      .post(global.url + API_URL.COMPANY.getAllCompaniesWithCount, details);
  }
  getAllAssosiatedCompaniesWithCount(query){
    console.log("query: ", query)
    const details = {
      ...query
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getAllAssosiatedCompaniesWithCount, details);
  }
  changeCompanyCarryForwardtatus(companyId, status){
    const payload = {
      companyId,
      userId:this.authService.currentUser._id,
      is_active: status
    }
    console.log(payload)
    return this.http
      .post(global.url + API_URL.COMPANY.changeCompanyCarryForwardStatus, { details: payload });
  }

  changeCompanyActiveStatus(companyId: string, status) {
    const payload = {
      companyId,
      is_active: status,
      userId: this.authService.currentUser._id
    }
    console.log(payload)
    return this.http
      .post(global.url + API_URL.COMPANY.changeCompanyActiveStatus, { details: payload });
  }
  companyChangeForUser(user_id, company_id, currentCompany_id?) {
    let details: any = {
      user_id,
      company_id,
      userId:this.authService.currentUser._id
    }
    if (currentCompany_id) details.currentCompany_id = currentCompany_id;
    console.log('details........',details);

    return this.http
      .post(global.url + API_URL.COMPANY.companyChangeForUser, details);
  }
  companyChangeForFacility(facility_id, company_id) {
    const details = {
      facility_id,
      company_id,
    }
    return this.http
      .post(global.url + API_URL.COMPANY.companyChangeForFacility, details);
  }

  deletePayor(payor_id) {
    const details = {
      payor_id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.deletePayor, details);
  }

  addFacilityContact(data) {
    return this.http
      .post(global.url + API_URL.COMPANY.addFacilityContact, data);
  }

  updateFacilityContact(data) {
    return this.http
      .post(global.url + API_URL.COMPANY.updateFacilityContact, data);
  }

  getFacilityContacts(data, associated_option?) {
    data = {
      ...data,
      associated_option: associated_option
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getFacilityContacts, data);
  }

  updateCompany(data) {
    
    data = {
      ...data,
      userId: this.authService.currentUser._id
    }
    // const observable = this.http
    //   .post(global.url + API_URL.COMPANY.updateCompany, data);

    // observable.subscribe((response: any) => {
    //   this.company.next(response.data);
    // })
    // return observable;
    return this.http.post(global.url + API_URL.COMPANY.updateCompany, data);
  }

  updateFacesheetSetting(data) {
    data = {
      ...data,
    }
    return this.http.post(global.url + API_URL.COMPANY.updateFacesheetSetting, data);
  } 

  

  updateIPASetting(data) {
    data = {
      ...data,
    }
    return this.http.post(global.url + API_URL.COMPANY.updateIPASetting, data);
  }

  updateFacesheetExtactionSetting(data) {
    data = {
      ...data,
    }
    return this.http.post(global.url + API_URL.COMPANY.updateFacesheetExtactionSetting, data);
  }

  updateNoteUploadingMethodSetting(data) {
    data = {
      ...data,
    }
    return this.http.post(global.url + API_URL.COMPANY.updateNoteUploadingMethodSetting, data);
  }

  userCreatePassword(data) {
    return this.http.post(global.url + API_URL.COMPANY.userCreatePassword, data);
  }
  createStrongPassword(data) {
    return this.http.post(global.url + API_URL.COMPANY.createStrongPassword, data);
  }
  verifyCode(data) {
    return this.http.post(global.url + API_URL.COMPANY.verifyCode, data);
  }
  resendConfirmationCode(data) {
    return this.http.post(global.url + API_URL.COMPANY.resendConfirmationCode, data);
  }

  getPayors(filter, projection = {}) {
    const details = {
      filter, projection
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getPayors, details);
  }

  ResendEmail(userId) {
    const details = {
      ...this.authService.authObject,
      userId
    }
    return this.http
      .post(global.url + API_URL.COMPANY.ResendEmail, { details });
  }

  downloadAsXLSX(data) {
    const details = {
      // ...this.authService.authObject,
      data
    }
    // return this.http
    //     .post(global.url + API_URL.COMPANY.downloadAsXLSX, details);

    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Length');
    headers.append('Access-Control-Expose-Headers', 'Content-Length');
    headers.append('Content-Type', 'application/octet-stream');

    return this.httpclient.post(global.url + API_URL.COMPANY.downloadAsXLSX, details,
      {
        responseType: "blob",
        reportProgress: true,
        observe: 'events',
        headers
      });
  }
  exportUsersAsXLSX(company_id, user_type?, user_status?, addionalUserRole = null) {
    let details;
    if (addionalUserRole) {
      details = {
        ...this.authService.authObject,
        company_id,
        user_type,
        user_status,
        addionalUserRole
      }
    } else {
      details = {
        ...this.authService.authObject,
        company_id,
        user_type,
        user_status,
      }
    }

    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Length');
    headers.append('Access-Control-Expose-Headers', 'Content-Length');
    headers.append('Content-Type', 'application/octet-stream');

    return this.httpclient.post(global.url + API_URL.COMPANY.exportUsersAsXLSX, details,
      {
        responseType: "blob",
        reportProgress: true,
        observe: 'events',
        headers
      });
  }
  getPccFacilityActivationNote(company_id) {
    const details = {
      ...this.authService.authObject,
      company_id
    }
    return this.http
      .post(global.url + API_URL.COMPANY.getPccFacilityActivationNote, details);
  }
  setPccFacilityActivationNote(company_id, note) {
    const details = {
      ...this.authService.authObject,
      company_id,
      note
    }
    return this.http
      .post(global.url + API_URL.COMPANY.setPccFacilityActivationNote, details);
  }

  saveCompanyImages(data) {
    const formData = new FormData();

    // Append files to FormData
    data.forEach((value, key) => {
      formData.append(key, value);
    });

    // Add additional properties
    formData.append('userId', this.authService.currentUser._id);
    return this.httpclient
      .post(global.url + API_URL.COMPANY.saveCompanyImages, data);
  }

  saveCompanyModifier(data) {

    let detail = {
      ...data,
      userId: this.authService.currentUser._id
    }
    console.log("detail : ", data, detail);
    return this.httpclient
      .post(global.url + API_URL.COMPANY.saveCompanyModifier, detail);
  }


  updateCptRelation(companyId,cptId,isCreating) {
    const details = {
      ...this.authService.authObject,
      companyId,
      cptId,
      isCreating
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.updateCptRelation, details).pipe();
  }

  updateCompanyCptRelationForModifier(companyId,cptId,isCreating) {
    const details = {
      ...this.authService.authObject,
      companyId,
      cptId,
      isCreating
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.updateCompanyCptRelationForModifier, details).pipe();
  }

  createCptTimeRelation(companyId ,model: {}) {
    const details = {
      ...this.authService.authObject,
      companyId,
      model,
    }
    return this.httpclient.post(global.url + API_URL.CPT.createCptTimeRelation, details).pipe();
  }
  updateCptTimeRelation(_id, companyId, cptId, isCreating) {
    const details = {
      ...this.authService.authObject,
      _id,
      companyId,
      cptId,
      isCreating,
    }
    return this.httpclient.post(global.url + API_URL.CPT.updateCptTimeRelation, details).pipe();
  }
  getCptTimeAssociations(companyId) {
    const details = {
      ...this.authService.authObject,
      companyId,
    }
    return this.httpclient.post(global.url + API_URL.CPT.getCptTimeAssociations, details).pipe();
  }
  
  getCompanyCPTRelations(filter,projection,populate = {}) {
    return this.httpclient.post(global.url + API_URL.COMPANY.getCompanyCPTRelations,{filter, projection,populate} ).pipe();
  }
  getIEFUCodesMapping(company_id, populate = null){
    let data = {
      company_id,
      populate
    }
    return this.httpclient.post(global.url + API_URL.COMPANY.getIEFUCodesMapping, {details: data}).pipe();
  }
  updateIEFUCodesMapping(data){
    return this.httpclient.post(global.url + API_URL.COMPANY.updateIEFUCodesMapping, {details: data}).pipe();
  }
  getCompany(filter, projection, populate = {}) {
    return this.httpclient.post(global.url + API_URL.COMPANY.getCompany, {filter, projection, populate});
  }
  initAssociatedCompanies(filter) {
    return this.httpclient.post(global.url + API_URL.COMPANY.initAssociatedCompanies, filter);
  }
  getAllPermissions(filter, project) {
    return this.httpclient.post(global.url + API_URL.COMPANY.getAllPermissions, { filter, project });
  }
  modifyCompany(filter, updateQuery, options?) {
    return this.httpclient.post(global.url + API_URL.COMPANY.modifyCompany, { filter, updateQuery, options });
  }

  async checkCompanyPermission(keys: string | string[], companyId: string) :Promise<any> {
    const filter = {
      _id: companyId
    };
    const project = {
      name: 1,
      permissions: 1
    };
    const populate = {
      permissions: "key value"
    };
    const response: any = await lastValueFrom(this.getCompany(filter, project, populate));
    if (response.status === 200) {
      const permissions = response.data.permissions;
      if (Array.isArray(permissions) && permissions.length > 0) {
        if(typeof keys === 'string')
        return permissions.some(permission => permission.key === keys);
        if(Array.isArray(keys) && keys.length > 0) {
          return Promise.resolve(this.validateCompanyPermission(permissions, keys));
        }
      }
      
    }
    return Promise.resolve(false);
  }
  validateCompanyPermission(permissions: any[], keys: string[]) {
    let privileges = [];
    privileges = keys.map(key => permissions.some(permission => permission.key === key));
    return privileges;
  }

  saveDragonToken(data: { company_id: string; token: string }) {
    return this.http.post(global.url + API_URL.COMPANY.saveDragonToken, data);
  }

  async getDragonToken(company_id: string): Promise<string> {
    return await lastValueFrom(this.httpclient.get<string>(`${global.url + API_URL.COMPANY.getDragonToken}?company_id=${company_id}`));
  }

}